import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
  IonSpinner,
  IonTextarea,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import {
  BhpMarketTypes,
  BhpThemeHeaderWithBack,
  BusinessDetailsType,
  BusinessHomePageSection,
} from "../pages/BussinessHomePage";
import ContentWithBackground from "../UI/ContentWithBackground";
import { star, starOutline } from "ionicons/icons";
import axios from "axios";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  getPageType,
  queryBhpTestimonialsDetailsDB,
  saveBhpTestimonialsDetailsDB,
} from "../types/constants";
import { getSessionDetails } from "../common/cookies";
import {
  getUID,
  useAppDispatch,
  useAppSelector,
  useCustomToast,
  useRecordUserInteractions,
  useStringToast,
  userActionsTable,
} from "../app/hooks";
import { AlertWithoutExecTypes } from "../types/data_types";
import AlertWithoutExec from "../UI/AlertWithoutExec";
import { setOptions } from "react-chartjs-2/dist/utils";
import { reviewCredentialsInfoActions } from "../store/review-credential-info-slice";
import { getCurrentDateString } from "../common/commonFunctions";

const BhpTestimonialModal: React.FC<{
  vypzeePage?: boolean;
  open: boolean;
  onDismiss: (id: number) => void;
  id: string | number;
  isMarket: boolean;
  name: string;
  marketType?: BhpMarketTypes;
  reviewNotAutoApprove?: boolean;
  onDidReviewDone: () => void;
}> = (props) => {
  const { name, phone } = useAppSelector((state) => state.reviewCredintials);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedack] = useState("");
  const dispatch = useAppDispatch();
  const onDidDismiss = (id: number = undefined) => {
    // setName("");
    // setPhone("");
    setRating(0);
    setFeedack("");
    props.onDismiss(id);
  };
  const stars = [0, 0, 0, 0, 0];
  const [reviewedId, setReviewedId] = useState(0);
  const { token } = getSessionDetails();
  const [saving, setSaving] = useState(false);
  const stringToast = useStringToast();
  const presentToast = useCustomToast();
  const [alert, setAlert] = useState<AlertWithoutExecTypes>({
    message: "",
    open: false,
  });
  const openAlert = (inp: string) => {
    setAlert({ message: inp, open: true });
  };
  const recordAction = useRecordUserInteractions();

  const [errorName, setErrorName] = useState(false);
  const [errorPhone, setErrorPhone] = useState(false);

  useEffect(() => {
    if (errorName && !!name) {
      setErrorName(false);
    }
  }, [name, errorName]);

  useEffect(() => {
    if (errorPhone && (!phone.length || phone.length === 10)) {
      setErrorPhone(false);
    }
  }, [phone, errorPhone]);

  const nameInputRef = useRef(null);

  const validInputs = (): boolean => {
    if (!rating) {
      openAlert("Please enter a valid rating");
      return false;
    }
    if (name.length < 3) {
      openAlert("Please enter a valid name");
      nameInputRef.current.setFocus();
      setErrorName(true);
      return false;
    }
    if (phone && phone.length !== 10) {
      openAlert("Please enter a valid 10 digit phone");
      setErrorPhone(true);
      return false;
    }
    return true;
  };

  const { id } = getSessionDetails();

  useEffect(() => {
    const queryTestimonials = () => {
      axios
        .post(
          `${IDIGIZEN_BACKEND_URL}/${queryBhpTestimonialsDetailsDB}`,
          JSON.stringify({
            uid: getUID(),
            shopId: props.id,
            isMarket: props.isMarket,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              authorization: API_SECURE_KEY,
            },
            params: {
              token,
              id,
            },
          }
        )
        .then((res) => {
          console.log("JDE ", res);
          if (res.data.data.success) {
            setRating(res.data.data.retVal.score);
            setFeedack(res.data.data.retVal.feedback);
            dispatch(
              reviewCredentialsInfoActions.updateName({
                name: res.data.data.retVal.customerName,
              })
            );
            dispatch(
              reviewCredentialsInfoActions.updatePhone({
                phone: res.data.data.retVal.customerPhone,
              })
            );
            setReviewedId(res.data.data.retVal.id);
            dispatch(
              reviewCredentialsInfoActions.updateReviewId({
                id: res.data.data.retVal.id,
              })
            );
          }
        })
        .catch((e) => {
          presentToast(e);
        });
    };
    if (!!props.open && !!props.id) queryTestimonials();
  }, [props.open, props.id]);

  const save = async () => {
    try {
      if (!validInputs()) return;
      setSaving(true);
      recordAction({
        action: userActionsTable.submitReview,
        pageId: props.id,
        pageSection: "MAIN",
        pageType: getPageType(props.isMarket, props?.marketType),
        notes: `Ph:${phone}:: ${rating}-${feedback}`,
      });
      const res = await axios.post(
        `${IDIGIZEN_BACKEND_URL}/${saveBhpTestimonialsDetailsDB}`,
        JSON.stringify({
          name,
          phone,
          shopId: props.id,
          feedback,
          rating,
          shopType: props.isMarket ? "MARKET" : "SHOP",
          reviewNotAutoApprove: props?.reviewNotAutoApprove,
          uid: getUID(),
          reviewedId,
        }),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: API_SECURE_KEY,
          },
          params: {
            token,
            id,
          },
        }
      );
      setSaving(false);
      // stringToast("Thank you! Your review is recorded.");
      openAlert(`Thank you! Your review is recorded.`);
      props.onDidReviewDone();
      onDidDismiss(res.data.data.recordId);
      console.log("JDE Update record ID ", res.data.data.recordId);
      dispatch(
        reviewCredentialsInfoActions.updateReviewId({
          id: res.data.data.recordId,
        })
      );
    } catch (e) {
      console.log("Failed to save customer testimonial error =", e);
      setSaving(false);
      presentToast(e);
    }
  };

  return (
    <>
      <AlertWithoutExec openAlert={alert} setOpenAlert={setAlert} />
      <IonModal
        isOpen={props.open}
        onDidDismiss={() => {
          onDidDismiss();
          setReviewedId(0);
        }}
        initialBreakpoint={0.9}
        breakpoints={[0.9, 1]}
      >
        <BhpThemeHeaderWithBack
          title={`${
            props.vypzeePage ? "Us" : props.isMarket ? "Market" : "Store"
          } Review`}
          onBack={() => {
            onDidDismiss();
          }}
        />
        <ContentWithBackground>
          {!!reviewedId && (
            <div
              style={{
                fontSize: "0.8rem",
                padding: "10px",
                background:
                  "linear-gradient(to right bottom, rgba(0,0,0,0.9), rgba(0,0,0,0.7))",
                color: "var(--ion-color-light)",
              }}
            >
              <div>
                Dear <b>{name}</b>, You have reviewed shop <b>{props.name}</b>{" "}
                on {getCurrentDateString()}
              </div>
              <div style={{ color: "yellow", paddingTop: "3px" }}>
                Would you like to update the review?
              </div>
            </div>
          )}
          <BusinessHomePageSection subHeaderText="Review">
            <IonGrid>
              <IonRow>
                {stars.map((el, idx) => {
                  const fill = rating >= idx + 1;
                  return (
                    <IonCol
                      key={idx}
                      size={"2.4"}
                      onClick={() => {
                        setRating(idx + 1);
                      }}
                    >
                      <div
                        style={{
                          fontSize: "2rem",
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <IonIcon
                          icon={fill ? star : starOutline}
                          color={fill ? "warning" : "medium"}
                        />
                      </div>
                    </IonCol>
                  );
                })}
              </IonRow>
            </IonGrid>
            <IonItem>
              <IonLabel color={"tertiary"} position="stacked">
                Additional Comments
              </IonLabel>
              <IonTextarea
                autoGrow={true}
                placeholder="Optional"
                value={feedback}
                onIonChange={(e) => {
                  setFeedack(e.detail.value);
                }}
              />
            </IonItem>
          </BusinessHomePageSection>
          <BusinessHomePageSection subHeaderText="Personal Details">
            <IonItem className={errorName ? "ion-input-danger-bg" : ""}>
              <IonLabel
                position="stacked"
                color={errorName ? "dark" : "tertiary"}
              >
                Name<span style={{ color: "red" }}>*</span>
              </IonLabel>
              <IonInput
                ref={nameInputRef}
                value={name}
                onIonChange={(e) => {
                  // setName(e.detail.value);
                  dispatch(
                    reviewCredentialsInfoActions.updateName({
                      name: e.detail.value,
                    })
                  );
                }}
              />
            </IonItem>
            <IonItem className={errorPhone ? "ion-input-danger-bg" : ""}>
              <IonLabel
                position="stacked"
                color={errorPhone ? "dark" : "tertiary"}
              >
                10 Digit Phone (We will not spam you)
              </IonLabel>
              <IonInput
                maxlength={10}
                type="number"
                value={phone}
                onIonChange={(e) => {
                  // setPhone(e.detail.value);
                  dispatch(
                    reviewCredentialsInfoActions.updatePhone({
                      phone: e.detail.value,
                    })
                  );
                }}
              />
            </IonItem>
          </BusinessHomePageSection>
          <div style={{ display: "flex", padding: "5px", background: "white" }}>
            <div style={{ width: "50%" }}>
              <IonButton expand="block" onClick={save}>
                {!saving && <>{!reviewedId ? "Submit" : "Update"}</>}
                {!!saving && <IonSpinner color={"light"} />}
              </IonButton>
            </div>
            <div style={{ width: "50%" }}>
              <IonButton
                expand="block"
                fill="clear"
                color={"danger"}
                onClick={() => {
                  onDidDismiss();
                }}
              >
                Cancel
              </IonButton>
            </div>
          </div>
        </ContentWithBackground>
      </IonModal>
    </>
  );
};

export default BhpTestimonialModal;
